import { useState, useEffect } from 'react'
import Store from '../Store/Store';
import getData from '../Admin/getData';
import PagesHeader from '../AdminPages/PagesHeader';
import PagesRows from '../AdminPages/PagesRows';
import Update from '../Admin/Update/Update';


const New = props => (
	<div 
		className="new"
		onClick={ e => props.setRowId( true ) }
		style={{ 
			background:'#fff', fontSize:12, fontWeight:700,  
			cursor:'pointer', padding:'5px 10px', margin:'0 8px', 
			border:'1px solid #444', 
		}}
	>
		New
	</div>
)

const Title = props => <div 
	style={{ display:'flex', alignItems:'center', margin:'10px 0 5px 20px', ...props.titleStyle }} >
		<div 
			style={{ display:'flex', margin:'10px 10px 10px 0', fontSize:18, fontWeight:600, cursor:'pointer' }} 
			onClick={ e => { props.setRowId( false ) } }
		>
			<div className="material-symbols-outlined" >
				{ props.rowId ? 'arrow_drop_up' : 'arrow_drop_down' }
			</div>
			<div>{ props.title }</div>
		</div> 
		{ props.rowId === false && props.allowInsert &&
			<New setRowId={ props.setRowId } />
		}
</div>


export default function Table( props ) {

	const table = props.table
	const showColumns = props.showColumns
	const api = props.api
	const id = props.id

	const select = props.select 
	const selectedId = props.selectedId 
	const setSelectedId = props.setSelectedId

	const showPreview = props.showPreview

	const [ structure, setStructure ] = useState( Store.get( 'structure' ) || {} )
	const [ rows, setRows ] = useState( Store.get( props.api + '-' + props.id ) || [] ) 
	const [ rowId, setRowId ] = useState( false ) 

	useEffect( () => setRowId( false ), [ id ] ) ;
	useEffect( () => getData( 'structure', setStructure, d => Store.set( 'structure', d ) ), [] )
	useEffect( () => {
		if ( id !== null ) getData( api + '/' + id, setRows, d => Store.set( api + '-' + id, d ) )
	}, [ table, id, rowId, selectedId ] ) ;

	const commonProps = { showPreview, structure, table, showColumns, rows, rowId, setRowId, select, selectedId, setSelectedId }

	return <>

		{ props.title && 
			<Title 
				rowId={ rowId } 
				setRowId={ setRowId }
				title={ props.title } 
				titleStyle={ props.titleStyle } 
				allowInsert={ props.allowInsert } 
			/> 
		}



		{ rowId  
		? <> 
			<Update insertDefaults={ props.insertDefaults } { ...commonProps } />
		  </>
		: <>
			<table style={{ fontSize:13, marginLeft:20, maxWidth:'100%', whiteSpace:'nowrap' }} >
				<tbody>
					<PagesHeader { ...commonProps } />
					<PagesRows { ...commonProps } />
				</tbody>
			</table>
		  </>
		}

	</>
}


